export const parseResponse = async response => {
  let json;

  try {
    json = await response.json();
  } catch {
    throw new Error('UNKNOWN');
  }

  if (!response.ok) {
    throw new Error(json.message || 'UNKNOWN');
  }
  return json;
};
